export const AvailableHomeWidgets = [
  'licensePlate',
  'licensePlateBGB',
  'actions',
  'fetch',
  'activeShipments',
  'historyShipments',
  'activeBgbShipments',
  'historyBgbShipments',
  'checkActivationBgb',
] as const

export const AvailableMenuWidgets = [
  'licensePlate',
  'licensePlateBGB',
  'queue',
  'styleChange',
  'deleteRegistration',
  'activeShipments',
  'historyShipments',
  'activeBgbShipments',
  'historyBgbShipments',
  'cancelShipment',
  'switchEmployer',
  'disclaimer',
  'signOut',
] as const
